<ion-list #list>
	@for (activity of activities; track activity.id) {
		<ion-item data-test="activity-list-item" lines="none" slot="start">
			<activity-item class="task-item" [activity]="activity" />
		</ion-item>
	}
</ion-list>
